import { IconProps } from '@acceso/design-system';

import { BoxRow } from '@/features/broadcast-schedule-program/types';
import { I18nextTranslationKeys } from '@/i18n/i18next';

enum ESegmentToolkit {
  TIMEKEEPING = 'TIMEKEEPING',
  LOGOTIPO = 'LOGOTIPO',
  PERSONAS = 'PERSONAS',
  DECLARACIONES = 'DECLARACIONES',
  ROTULOS = 'ROTULOS',
  MENCIONES = 'MENCIONES',
  CORTES = 'CORTES',
  INFORMACION = 'INFORMACION',
}
enum EClipToolkit {
  TIMEKEEPING = 'TIMEKEEPING',
  LOGOTIPO = 'LOGOTIPO',
  PERSONAS = 'PERSONAS',
  DECLARACIONES = 'DECLARACIONES',
  ROTULOS = 'ROTULOS',
  MENCIONES = 'MENCIONES',
  INFORMACION = 'INFORMACION',
}

type TToolkit = {
  label: I18nextTranslationKeys;
  value: ESegmentToolkit;
  icon: (props: IconProps) => JSX.Element;
  countable?: boolean;
};

type TBroadcastScheduleProgramSegementToolkitCommonItem = {
  id: string;
  timeline: Date;
};

type TBroadcastScheduleProgramBodySegmentToolkitRotuloItem =
  TBroadcastScheduleProgramSegementToolkitCommonItem & {
    rotulo: string;
    fiable: string;
    boxes?: BoxRow;
    children?: TBroadcastScheduleProgramBodySegmentToolkitRotuloItem[];
  };

type TBroadcastScheduleProgramBodySegmentToolkitMentionItem =
  TBroadcastScheduleProgramSegementToolkitCommonItem & {
    mention: string;
    interlocutor: string;
    boxes?: BoxRow;
  };

type TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem = {
  workspaceId: string;
  keyword: string;
  clientId: string;
  isTentative?: boolean;
  queryId?: string;
};

type TNavigationItem = {
  id?: string;
  children?: TNavigationItem[];
};

export { EClipToolkit, ESegmentToolkit };
export type {
  TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem,
  TBroadcastScheduleProgramBodySegmentToolkitMentionItem,
  TBroadcastScheduleProgramBodySegmentToolkitRotuloItem,
  TNavigationItem,
  TToolkit,
};
